module.exports = __webpack_public_path__ + "img/logo-kai.6e85a5f4.svg";